/* eslint-disable @typescript-eslint/no-use-before-define */
import moment from 'moment-timezone'

export default ['$scope', 'timePickerService', quickTimePickerController]
function quickTimePickerController($scope, timePickerService) {
  const dateTimeFormatWithTime = (date) => {
    const lang = window.navigator.language
    // const timeZone = window.org_settings.timezone
    return new Intl.DateTimeFormat(lang, {
      hour: 'numeric',
      minute: 'numeric',
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
    }).format(date)
  }

  this.quickTimes = []
  this.timezone = null
  this.$onInit = function () {
    this.timezone = window.org_settings.timezone
    timePickerService.fetchPickers().then(
      function (pickers) {
        this.quickTimes = timePickerService
          .parseDatums(this.nsKey, pickers)
          .map((date) => {
            return {
              time: date,
              displayDate: dateTimeFormatWithTime(date),
            }
          })
      }.bind(this)
    )
  }
  this.update = function (time) {
    const selectedTimeDateObject = moment(time).tz(
      window.org_settings.timezone,
      true
    )
    this.ngModel.$setViewValue(selectedTimeDateObject)
    this.ngModel.$render()
  }.bind(this)
}
